var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step_header"},[_c('div',{staticClass:"step_title form_title"},[_c('h3',[_vm._v("Ви заповнили "+_vm._s(_vm.load)+" заявки")])]),_vm._v(" "),_c('div',{staticClass:"form_progress"},[_c('div',{staticClass:"form_progress-load",style:(_vm.proggress())})])])
}
var staticRenderFns = []

export { render, staticRenderFns }